var React = require('react');

function MenuPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5917 11.0085L12.4984 8.91519C11.7508 8.16759 10.4799 8.46666 10.1808 9.43852C9.95656 10.1114 9.20895 10.4852 8.53611 10.3356C7.0409 9.96184 5.02237 8.01807 4.64856 6.4481C4.42428 5.77522 4.87284 5.02762 5.54569 4.80336C6.51758 4.50432 6.81662 3.23339 6.06901 2.48579L3.97572 0.392493C3.37763 -0.130831 2.48051 -0.130831 1.95719 0.392493L0.536735 1.81294C-0.883714 3.30815 0.686257 7.27046 4.2 10.7842C7.71374 14.298 11.6761 15.9427 13.1713 14.4475L14.5917 13.027C15.1151 12.4289 15.1151 11.5318 14.5917 11.0085Z","fill":"white"}));
}

MenuPhone.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = MenuPhone;

MenuPhone.default = MenuPhone;
